function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1359",
  "data-name": "Group 1359"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_976",
  "data-name": "Group 976",
  transform: "translate(11.515 0) rotate(45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_470",
  "data-name": "Group 470",
  transform: "translate(9.237 4.01) rotate(45)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1388",
  "data-name": "Rectangle 1388",
  width: 1.013,
  height: 10.212,
  fill: "#727272"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1361",
  "data-name": "Group 1361"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_1100",
  "data-name": "Path 1100",
  transform: "translate(0 0)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 4 1 C 2.345790863037109 1 1 2.345790863037109 1 4 L 1 16 C 1 17.65420913696289 2.345790863037109 19 4 19 L 16 19 C 17.65420913696289 19 19 17.65420913696289 19 16 L 19 4 C 19 2.345790863037109 17.65420913696289 1 16 1 L 4 1 M 4 0 L 16 0 C 18.20914077758789 0 20 1.790859222412109 20 4 L 20 16 C 20 18.20914077758789 18.20914077758789 20 16 20 L 4 20 C 1.790859222412109 20 0 18.20914077758789 0 16 L 0 4 C 0 1.790859222412109 1.790859222412109 0 4 0 Z",
  stroke: "none",
  fill: "#727272"
}))));

function SvgMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CLOSE_BOX",
    "data-name": "CLOSE BOX",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.2ad1531e.svg";
export { ForwardRef as ReactComponent };